module.exports = __webpack_public_path__ + "img/examWarning.c8e00016.png";